var map = {
	"./faq-policyholder.json": "./app/js/portal/config/faq-policyholder.json",
	"./faq-producer.json": "./app/js/portal/config/faq-producer.json",
	"./faq-vendor.json": "./app/js/portal/config/faq-vendor.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error('Cannot find module "' + req + '".');
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/js/portal/config sync recursive ^\\.\\/faq\\-.*\\.json$";